import Component from 'vue-class-component';
import Vue from 'vue';
import store from 'store/store.js';
import TimeTracking from './TimeTracking.js';
import TimeTrackingModel from './TimeTrackingModel.js';

@Component
export default class TimeTrackingContainer extends Vue {
    constructor() {
        super();
        this.items = this.$attrs.items;

    }
    created() {
        this.container = this.$attrs.container;
        this.updateTasks(this.items.id, this.items.jira_id);
    }
    render(h) {
        return (
            <div>
                <TimeTracking container={this}
                items={this.items}
                />
            </div>
        );
    }
    beforeUpdate() {
        this.setTasks(this.items.id, this.items.jira_id);
    }
    /*Store Manipulate Methods*/
    setTasks(id, jira_id) {
        TimeTrackingModel.setTasksValues(TimeTrackingModel.getDate()[0], this.items.day, id, jira_id);
    }
    updateReport() {
        TimeTrackingModel.changeReport();
        TimeTrackingModel.setReportValues(TimeTrackingModel.getDate()[1], TimeTrackingModel.getDate()[2]);
    }
    updateTasks(id, jira_id) {
        TimeTrackingModel.changeTasks();
        TimeTrackingModel.setTasksValues(TimeTrackingModel.getDate()[0], this.items.day, id, jira_id);
    }
    postWriteOff(data, id, jira_id, is_inside, total_time_count, difference) {
        TimeTrackingModel.postWriteOff(data, is_inside, total_time_count, difference);
        this.updateTasks(id, jira_id);
    }
    /*Output Components*/
    getCommHowMuch(){
        let comm_howmuch_list = [
            "1 час",
            "2 часа",
            "3 часа",
            "4 часа",
            "5 часов",
            "6 часов",
            "7 часов",
            "8 часов",
            "9 часов",
            "10 часов",
            "2 суток",
            "3 суток",
            "4 суток",
            "5 суток"
        ];

        return comm_howmuch_list;
    }

    getTimeTracking(index) {
        let tt = store.getters.timeTracking;
        let buf = 0;
        if (tt != -1) {
            tt.forEach(element => {
                if (element.day == index) {
                    buf = element.count;
                }
            });
        }
        return buf;
    }

    getWriteOffJira(day) {
        //теперь count_remaining тянется из моноцероса
        //его нужно сравнить с тасками и задачами в моноцеросе
        
        let t = store.getters.tasksJira;
        let t_m = store.getters.tasksMonoceros;
        let all_tasks = this.getAllTasks();

        let buf = [{
            task_id: "",
            task_title: "",
            status: "",
            count: "",
            count_remaining: "",
            comm_made: ""
        }];

        if (t != -1 && t_m != -1) {
            buf = [];
            let bufer = [];
            var buffer_jira_id_from_tasks = []
            var buffer_jira_id_from_monoceros = []
            var buffer_count_remaining = []

            all_tasks.forEach(el => {
                buffer_jira_id_from_tasks.push(
                    el.jira_task_id
                );
            });
            
            t_m.forEach(el => {
                buffer_jira_id_from_monoceros.push(
                    el.jira_id
                );
                buffer_count_remaining.push(
                    el.count_remaining
                );
            });
            

            t.forEach(element => {
                element.body.forEach(el_body => {
                    
                    let index_of_jira_id_from_monoceros = buffer_jira_id_from_monoceros.indexOf(element.id)
                    let index_of_jira_id_from_all_tasks = buffer_jira_id_from_tasks.indexOf(element.id)

                    if (index_of_jira_id_from_monoceros >= 0 && index_of_jira_id_from_all_tasks >= 0) {
                        
                        buf.push({
                            task_id: element.id,
                            task_title: element.title,
                            status: element.status,
                            count: el_body.count,
                            count_remaining: buffer_count_remaining[index_of_jira_id_from_monoceros],
                            comm_made: el_body.comm_made
                        });

                    } else {

                        buf.push({
                            task_id: element.id,
                            task_title: element.title,
                            status: element.status,
                            count: el_body.count,
                            count_remaining: 0,
                            comm_made: el_body.comm_made
                        });

                    }
                });
            });
        }
        return buf;
    }
    getWriteOffMonoceros(day){
        let t = store.getters.tasksMonoceros;

        let buf = [{
            task_id: "",
            task_title: "",
            jira_task_id: "",
            status: "",
            count_remaining: "",
            track_id: "",
            count: "",
            comm_made: "",
            comm_whatremains: "",
            comm_howmuch: "",
            comm_problems: ""
        }];
        if (t != -1) {
            buf = [];
            let bufer = [];
            t.forEach(element => {
                element.body.forEach(el_body =>{
                    if (el_body.track_id ){
                        buf.push({
                            task_id: element.id,
                            task_title: element.title,
                            jira_task_id: element.jira_id,
                            status: element.status,
                            count_remaining: element.count_remaining,
                            track_id: el_body.track_id,
                            count: el_body.count,
                            comm_made: el_body.comm_made,
                            comm_whatremains: el_body.comm_whatremains,
                            comm_howmuch: el_body.comm_howmuch,
                            comm_problems: el_body.comm_problems
                        });
                    }
                });
            });
        }
        return buf;
    }
    getAllTasks(){
        let t_m = store.getters.tasksMonoceros;
        let t_j = store.getters.tasksJira;

        let buf = [{
            task_id: "",
            jira_task_id: "",
            task_title: "",
            status: "",
            hidden: ""
        }];

        if (t_m != -1 && t_j != -1) {
            let buffer_jira_id = [];
            let buffer_id = [];
            t_m.forEach(el => {
                buffer_jira_id.push(
                    el.jira_id
                );
            });
            t_j.forEach(el => {
                buffer_id.push(
                    el.id
                );
            });

            buf = [];

            buf.push({
                task_id: -1,
                jira_task_id: -1,
                task_title: "---",
                status: "",
                count_remaining: 0,
                disabled_status: true,
                hidden: ""
            });

            t_m.forEach(el_body => {
                if (el_body.status == "Closed" ||
                    el_body.status == "Resolved" ||
                    el_body.status == "Done" ||
                    el_body.status == "Canceled" ||
                    el_body.status == "Test"){
                    if (buffer_id.indexOf(el_body.jira_id) >= 0) {
                        buf.push({
                            task_id: el_body.id,
                            jira_task_id: el_body.jira_id,
                            task_title: el_body.title,
                            status: el_body.status,
                            disabled_status: true,
                            count_remaining: el_body.count_remaining,
                            hidden: "display: none;"
                        });
                    } else {
                        buf.push({
                            task_id: el_body.id,
                            jira_task_id: el_body.jira_id,
                            task_title: el_body.title,
                            status: el_body.status,
                            count_remaining: el_body.count_remaining,
                            hidden: "display: none;"
                        });
                    }
                } else {
                    if (buffer_id.indexOf(el_body.jira_id) >= 0) {
                        buf.push({
                            task_id: el_body.id,
                            jira_task_id: el_body.jira_id,
                            task_title: el_body.title,
                            status: el_body.status,
                            disabled_status: true,
                            count_remaining: el_body.count_remaining,
                            hidden: ""
                        });
                    } else {
                        buf.push({
                            task_id: el_body.id,
                            jira_task_id: el_body.jira_id,
                            task_title: el_body.title,
                            status: el_body.status,
                            count_remaining: el_body.count_remaining,
                            hidden: ""
                        });
                    }
                }
            });
        }
        return buf;
    }
    getAllStatuses(){
        let t = store.getters.statuses;
        let buf = [[" ", " "]];
        if(t != -1){
            buf = t;
        }

        return buf;
    }
    getDateForPost(d){
        let day = d;
        let month = TimeTrackingModel.getDate()[2] + 1;
        let year = TimeTrackingModel.getDate()[1];

        if(day<10){
            day = "0"+day;
        }
        if(month<10){
            month = "0"+month;
        }
        return day+"-"+month+"-"+year;
    }
}



// WEBPACK FOOTER //
// ./src/TimeTrackingModal/TimeTrackingContainer.js